import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "ID Pajak Barang", -1)
const _hoisted_3 = { class: "my-1 font-normal" }
const _hoisted_4 = { class: "text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Kota Asal", -1)
const _hoisted_6 = { class: "my-1 font-normal" }
const _hoisted_7 = { class: "text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Komoditas", -1)
const _hoisted_9 = {
  key: 0,
  class: "\n            my-1\n            text-gray-lp-300\n            px-2\n            inline-flex\n            capitalize\n            bg-gray-lp-200\n            rounded\n          "
}
const _hoisted_10 = {
  key: 1,
  class: "my-1 text-black-lp-300"
}
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Deminimus ")
const _hoisted_14 = { class: "ml-1 relative" }
const _hoisted_15 = { class: "my-1 font-normal text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Biaya Masuk ")
const _hoisted_19 = { class: "ml-1 relative" }
const _hoisted_20 = { class: "my-1 font-normal text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_21 = { class: "flex flex-row" }
const _hoisted_22 = { class: "w-1/3" }
const _hoisted_23 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" PPN ")
const _hoisted_25 = { class: "ml-1 relative" }
const _hoisted_26 = { class: "my-1 font-normal text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_27 = { class: "w-full" }
const _hoisted_28 = { class: "font-semibold text-black-lp-300 mb-2 flex flex-row" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" PPH ")
const _hoisted_30 = { class: "ml-1 relative" }
const _hoisted_31 = { class: "my-1 font-normal text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col text-12px xxl:text-14px border-b border-gray-lp-400" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Periode Pajak"),
  /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500 text-12px mt-2" }, " Pajak Barang akan berlaku sesuai dengan tanggal periode yang sudah dipilih. ")
], -1)
const _hoisted_34 = { class: "flex flex-row" }
const _hoisted_35 = { class: "text-12px xxl:text-14px text-black-lp-300 w-1/3" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Dimulai Dari", -1)
const _hoisted_37 = { class: "my-1 font-normal" }
const _hoisted_38 = { class: "text-12px xxl:text-14px text-black-lp-300 w-full" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Sampai", -1)
const _hoisted_40 = { class: "my-1 font-normal" }
const _hoisted_41 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Status Pajak Barang", -1)
const _hoisted_43 = { class: "my-1 font-normal" }
const _hoisted_44 = { class: "flex" }
const _hoisted_45 = { class: "capitalize" }
const _hoisted_46 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Tanggal Dibuat", -1)
const _hoisted_48 = { class: "my-1 font-normal" }
const _hoisted_49 = { class: "text-gray-lp-500" }
const _hoisted_50 = { class: "text-black-lp-300 text-12px xxl:text-14px w-4/5" }
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { class: "font-semibold" }, "Terakhir Diubah", -1)
const _hoisted_52 = { class: "my-1 font-normal" }
const _hoisted_53 = { class: "text-gray-lp-500" }
const _hoisted_54 = { class: "inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.fetchDetail,
    title: 
      `${_ctx.detailGoodsTax.goodsTaxOriginCityName} - ${_ctx.detailGoodsTax.goodsTaxCommodityName}`
    
  }, _createSlots({
    "sub-data": _withCtx(() => [
      _createVNode("div", _hoisted_41, [
        _hoisted_42,
        _createVNode("div", _hoisted_43, [
          _createVNode("div", _hoisted_44, [
            _createVNode("div", {
              class: ["rounded-full px-2 py-0 font-medium", _ctx.styleStatus]
            }, [
              _createVNode("span", _hoisted_45, _toDisplayString(_ctx.status), 1)
            ], 2)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_46, [
        _hoisted_47,
        _createVNode("div", _hoisted_48, _toDisplayString(_ctx.formatDate(_ctx.detailGoodsTax.goodsTaxCreatedAt)), 1),
        _createVNode("div", _hoisted_49, _toDisplayString(_ctx.detailGoodsTax.goodsTaxCreatedName), 1)
      ]),
      _createVNode("div", _hoisted_50, [
        _hoisted_51,
        _createVNode("div", _hoisted_52, _toDisplayString(_ctx.detailGoodsTax.goodsTaxUpdatedAt === "0001-01-01T00:00:00Z" ||
            _ctx.detailGoodsTax.goodsTaxUpdatedAt === "" ||
            _ctx.detailGoodsTax.goodsTaxUpdatedAt === null
              ? _ctx.formatDate(_ctx.detailGoodsTax.goodsTaxCreatedAt)
              : _ctx.formatDate(_ctx.detailGoodsTax.goodsTaxUpdatedAt)), 1),
        _createVNode("div", _hoisted_53, _toDisplayString(_ctx.detailGoodsTax.goodsTaxUpdatedAt === "0001-01-01T00:00:00Z" ||
            _ctx.detailGoodsTax.goodsTaxUpdatedAt === "" ||
            _ctx.detailGoodsTax.goodsTaxUpdatedAt === null
              ? _ctx.detailGoodsTax.goodsTaxCreatedName
              : _ctx.detailGoodsTax.goodsTaxUpdatedName), 1)
      ]),
      _createVNode("div", _hoisted_54, [
        (_ctx.isEditAble && _ctx.status !== 'expired')
          ? (_openBlock(), _createBlock(_component_button_fill, {
              key: 0,
              title: "Edit",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goEdit())),
              class: "px-8 bg-red-lp-300"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (!_ctx.isLoading)
      ? {
          name: "data",
          fn: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.detailGoodsTax.id), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.detailGoodsTax.goodsTaxOriginCityName?.replace(/,/gi, ", ")), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              (_ctx.detailGoodsTax.goodsTaxCommodityName !== '')
                ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.detailGoodsTax.goodsTaxCommodityName), 1))
                : (_openBlock(), _createBlock("div", _hoisted_10, "-"))
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("div", _hoisted_14, [
                  _createVNode("img", {
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOpenDeminimus(true))),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenDeminimus(false))),
                    src: 
                _ctx.isOpenDeminimus
                  ? require('@/app/ui/assets/svg/info-red.svg')
                  : require('@/app/ui/assets/svg/info.svg')
              ,
                    alt: ""
                  }, null, 40, ["src"]),
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "Deminimus",
                    message: "Batas minimum harga barang (Deminimus) saat ini adalah 3 $ per barang.",
                    footer: "",
                    isArrowBottom: false,
                    style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                  }, null, 512), [
                    [_vShow, _ctx.isOpenDeminimus]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.detailGoodsTax.goodsTaxDeminimus) + " $ ", 1)
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, [
                  _createVNode("img", {
                    onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onOpenBiayaMasuk(true))),
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onOpenBiayaMasuk(false))),
                    src: 
                _ctx.isOpenBiayaMasuk
                  ? require('@/app/ui/assets/svg/info-red.svg')
                  : require('@/app/ui/assets/svg/info.svg')
              ,
                    alt: ""
                  }, null, 40, ["src"]),
                  _withDirectives(_createVNode(_component_Tooltip, {
                    title: "Biaya Masuk",
                    message: "Tarif Biaya Masuk (BM) akan dikenakan untuk barang dengan nilai Deminimus lebih dari 3 $ sebesar 7,5% kecuali 4 komoditi (Tas, Sepatu, Produk Tekstil) akan dikenakan sebesar 15% - 20%, 25% - 30%, dan 15% - 25%.",
                    footer: "",
                    isArrowBottom: false,
                    style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                  }, null, 512), [
                    [_vShow, _ctx.isOpenBiayaMasuk]
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.detailGoodsTax.goodsTaxCoverCharge) + " % ", 1)
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode("div", _hoisted_25, [
                    _createVNode("img", {
                      onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onOpenPPN(true))),
                      onMouseleave: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onOpenPPN(false))),
                      src: 
                  _ctx.isOpenPPN
                    ? require('@/app/ui/assets/svg/info-red.svg')
                    : require('@/app/ui/assets/svg/info.svg')
                ,
                      alt: ""
                    }, null, 40, ["src"]),
                    _withDirectives(_createVNode(_component_Tooltip, {
                      title: "PPN",
                      message: "Besaran Pajak Pertambahan Nilai (PPN) adalah 10%.",
                      footer: "",
                      isArrowBottom: false,
                      style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                    }, null, 512), [
                      [_vShow, _ctx.isOpenPPN]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_26, _toDisplayString(_ctx.detailGoodsTax.goodsTaxPPN) + " % ", 1)
              ]),
              _createVNode("div", _hoisted_27, [
                _createVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode("div", _hoisted_30, [
                    _createVNode("img", {
                      onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onOpenPPH(true))),
                      onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onOpenPPH(false))),
                      src: 
                  _ctx.isOpenPPH
                    ? require('@/app/ui/assets/svg/info-red.svg')
                    : require('@/app/ui/assets/svg/info.svg')
                ,
                      alt: ""
                    }, null, 40, ["src"]),
                    _withDirectives(_createVNode(_component_Tooltip, {
                      title: "PPH",
                      message: "Tarif Pajak Penghasilan (PPh) akan dikenakan sebesar 7,5% - 10% untuk barang dengan nilai Deminimus lebih dari 3$.",
                      footer: "",
                      isArrowBottom: false,
                      style: {"width":"300px","margin-left":"2.6em","margin-top":"-2.6em"}
                    }, null, 512), [
                      [_vShow, _ctx.isOpenPPH]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.detailGoodsTax.goodsTaxPPH) + " % ", 1)
              ])
            ]),
            _hoisted_32,
            _hoisted_33,
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode("div", _hoisted_37, _toDisplayString(_ctx.formatDateWithoutTime(_ctx.detailGoodsTax.goodsTaxStartDate)), 1)
              ]),
              _createVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDateWithoutTime(_ctx.detailGoodsTax.goodsTaxEndDate)), 1)
              ])
            ])
          ])
        }
      : undefined
  ]), 1032, ["onBack", "loading", "error", "errorType", "onTryAgain", "title"]))
}